import React from 'react';
import QRCode from 'qrcode.react';
import logo from "../logo/ABK.png";

const BillPrint = ({ onClose, labelData }) => {
    // Function to format the date
    const formatDate = (dateString) => {
        const options = { year: 'numeric', month: 'long', day: 'numeric' };
        return new Date(dateString).toLocaleDateString('en-US', options);
    };

    // Styles for the invoice
    const containerStyle = {
        border: '1px solid #000',
        padding: '20px',
        fontFamily: 'Arial, sans-serif',
        color: '#333',
        lineHeight: '1.5',
        fontSize: '12px',
    };

    // Styles for the table cells
    const cellStyle = {
        border: '1px solid #000',
        padding: '8px',
    };

    const cellStyleN = {
        border: '1px solid #000',
        padding: '8px',
        textAlign: 'right'
    };

    const cellStyleP = {
        border: '1px solid #000',
        padding: '8px',
        textAlign: 'left'
    };


    // Styles for the table
    const tableStyle = {
        width: '100%',
        borderCollapse: 'collapse',
        textAlign: 'center',
        marginTop: '30px'
    };

    // Styles for the footer
    const footerStyle = {
        textAlign: 'center',
        marginTop: '20px',
        borderTop: '1px solid #eee',
        paddingTop: '10px',
    };

    const NumberToWords = (num) => {
        const units = ['', 'One', 'Two', 'Three', 'Four', 'Five', 'Six', 'Seven', 'Eight', 'Nine'];
        const teens = ['Eleven', 'Twelve', 'Thirteen', 'Fourteen', 'Fifteen', 'Sixteen', 'Seventeen', 'Eighteen', 'Nineteen'];
        const tens = ['', 'Ten', 'Twenty', 'Thirty', 'Forty', 'Fifty', 'Sixty', 'Seventy', 'Eighty', 'Ninety'];

        const convert = (num) => {
            if (num < 10) return units[num];
            if (num < 20) return num === 10 ? 'Ten' : teens[num - 11];
            if (num < 100) return tens[Math.floor(num / 10)] + (num % 10 ? ' ' + units[num % 10] : '');
            if (num < 1000) return units[Math.floor(num / 100)] + ' Hundred' + (num % 100 ? ' ' + convert(num % 100) : '');
            if (num < 100000) return convert(Math.floor(num / 1000)) + ' Thousand' + (num % 1000 ? ' ' + convert(num % 1000) : '');
            if (num < 10000000) return convert(Math.floor(num / 100000)) + ' Lakh' + (num % 100000 ? ' ' + convert(num % 100000) : '');
            return 'Number is too large';
        };

        if (num === 0) return 'Zero';
        return convert(num);
    };

    const AmountInWords = ({ amount }) => {
        const formattedAmount = parseFloat(amount).toFixed(2);
        const [rupees, decimal] = formattedAmount.split('.');

        return (
            <div>
                <h5>Rs: {NumberToWords(parseInt(rupees))} Only</h5>
                {decimal !== "00" && <p>{NumberToWords(parseInt(decimal))} Paisa Only</p>}
            </div>
        );
    };

    const totalDeductions = labelData.CleaningAmount + labelData.OtherAmount;
    // Render the invoice
    //     return (
    //         <div style={containerStyle}>
    //             <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '0px' }}>
    //                 <img src={logo} alt="Company Logo" style={{ maxHeight: '80px', margin: '0 auto', marginLeft: '250px' }} />
    //             </div>

    //             <div className="w-full sm:w-1/2">
    //                 <table style={{ width: '100%', borderCollapse: 'collapse' }}>
    //                     <tbody>
    //                         <tr>

    //                             <td style={{ width: '50%', textAlign: 'right', padding: 0 }}>
    //                                 <h3 style={{ textAlign: 'right', marginTop: '20px' }}>Bill No #{labelData.ReferenceNo}</h3>
    //                                 <h3 style={{ textAlign: 'right', padding: 0 }}>Bill Date: {formatDate(labelData.ReferenceDate)}</h3>
    //                             </td>
    //                         </tr>
    //                     </tbody>
    //                 </table>
    //             </div>

    //             <div className="w-full sm:w-1/2">
    //                 <table style={{ width: '100%', marginTop: '30px', borderCollapse: 'collapse' }}>
    //                     <tbody>
    //                         <tr>
    //                             <td style={{ width: '100%', textAlign: 'center', padding: 0 }}>
    //                                 <h2 style={{ textAlign: 'center', padding: '0 0 5px 0', margin: 0 }}>ABK Hostel - Caution Fee Refund Form</h2>
    //                             </td>

    //                         </tr>
    //                         <tr>
    //                             <td style={{ width: '100%', textAlign: 'center', padding: 0 }}>
    //                                 <h4 style={{ textAlign: 'left', padding: '0 0 5px 0', margin: 0 }}>Tenant Details</h4>
    //                             </td>

    //                         </tr>

    //                     </tbody>
    //                 </table>
    //             </div>

    //             <div className="w-full sm:w-1/2">
    //                 <table style={{ width: '100%', marginTop: '30px', borderCollapse: 'collapse' }}>
    //                     <tbody>
    //                         <tr>
    //                             <h4 style={{ textAlign: 'left', padding: '0 0 5px 0', margin: 0, fontWeight: 'normal' }}>Name       : {labelData.PartyName}</h4>
    //                         </tr>
    //                         <tr>
    //                             <h4 style={{ textAlign: 'left', padding: '0 0 5px 0', margin: 0, fontWeight: 'normal' }}>Room Number : {labelData.RoomName}</h4>
    //                         </tr>
    //                         <tr>
    //                             <h4 style={{ textAlign: 'left', padding: '0 0 5px 0', margin: 0, fontWeight: 'normal' }}>Check-in Date : {formatDate(labelData.CheckInDate)}</h4>
    //                         </tr>
    //                         <tr>
    //                             <h4 style={{ textAlign: 'left', padding: '0 0 5px 0', margin: 0, fontWeight: 'normal' }}>Check-out Date : {formatDate(labelData.CheckOutDate)}</h4>
    //                         </tr>
    //                         <tr>
    //                             <h4 style={{ textAlign: 'left', padding: '0 0 5px 0', margin: 0, fontWeight: 'normal' }}>Contact Number : {labelData.PartyContactNo}</h4>
    //                         </tr>
    //                     </tbody>
    //                 </table>
    //             </div>

    //             <div className="w-full sm:w-1/2">
    //                 <table style={{ width: '100%', marginTop: '30px', borderCollapse: 'collapse' }}>
    //                     <tbody>
    //                         <tr>
    //                             <td style={{ width: '100%', textAlign: 'center', padding: 0 }}>
    //                                 <h4 style={{ textAlign: 'Left', padding: '0 0 5px 0', margin: 0 }}>Refund Information: </h4>
    //                             </td>
    //                         </tr>


    //                     </tbody>
    //                 </table>
    //             </div>

    //             <div className="w-full sm:w-1/2">
    //                 <table style={{ width: '100%', marginTop: '30px', borderCollapse: 'collapse' }}>
    //                     <tbody>
    //                         <tr>
    //                             <h4 style={{ textAlign: 'left', padding: '0 0 5px 0', margin: 0, fontWeight: 'normal' }}>Total Caution Fee Paid: <span style={{ fontSize: '18px' }}>₹ : {labelData.CautionAmount}</span></h4>
    //                         </tr>
    //                         <tr>
    //                             <h4 style={{ textAlign: 'left', padding: '0 0 5px 0', margin: 0, fontWeight: 'normal' }}> Deductions (if any): <span style={{ fontSize: '18px' }}>₹ {totalDeductions}</span></h4>
    //                         </tr>
    //                         <tr>
    //                             <h4 style={{ textAlign: 'left', padding: '0 0 5px 0', margin: 0, fontWeight: 'normal' }}>Reason for Deductions: {labelData.Remarks}</h4>
    //                         </tr>
    //                         <tr>
    //                             <h4 style={{ textAlign: 'left', padding: '0 0 5px 0', margin: 0, fontWeight: 'normal' }}>Amount to be Refunded:  <span style={{ fontSize: '18px' }}>₹ {labelData.RefundAmount}</span></h4>

    //                         </tr>

    //                     </tbody>
    //                 </table>
    //             </div>

    //             <div className="w-full sm:w-1/2">
    //                 <table style={{ width: '100%', marginTop: '30px', borderCollapse: 'collapse' }}>
    //                     <tbody>
    //                         <tr>
    //                             <td style={{ width: '100%', textAlign: 'center', padding: 0 }}>
    //                                 <h4 style={{ textAlign: 'Left', padding: '0 0 5px 0', margin: 0 }}>Payment Type  : </h4>
    //                             </td>
    //                         </tr>
    //                         <tr>
    //                             <h4 style={{ textAlign: 'left', padding: '0 0 5px 0', margin: 0, fontWeight: 'normal' }}>{labelData.PaymentType}</h4>
    //                         </tr>
    //                         <tr>
    //                             <h4 style={{ textAlign: 'left', padding: '0 0 5px 0', margin: 0, fontWeight: 'normal' }}>{formatDate(labelData.PaymentSaledate)}</h4>
    //                         </tr>

    //                     </tbody>
    //                 </table>
    //             </div>
    //             <div className="w-full sm:w-1/2">
    //                 <table style={{ width: '100%', marginTop: '30px', borderCollapse: 'collapse' }}>
    //                     <tbody>
    //                         <tr>
    //                             <td style={{ width: '40%', textAlign: 'left', padding: 0 }}>
    //                                 <h4 style={{fontSize:'16px'}}><AmountInWords amount={labelData.RefundAmount} /></h4>
    //                             </td>
    //                             <td style={{ width: '60%', textAlign: 'right', padding: 0 }}>
    //                                 <h4 style={{ textTransform: 'uppercase' }}>For {labelData.CompanyName}</h4>
    //                                 <h4 style={{ marginTop: '25px', marginBottom: '2px' }}>Signature</h4>
    //                             </td>
    //                         </tr>
    //                     </tbody>
    //                 </table>
    //             </div>


    //             <style>
    //                 {`
    //                     @media print {
    //                         body {
    //                             margin: 10;
    //                             padding: 0;
    //                         }
    //                         @page {
    //                             size: A4;
    //                             margin: 0;
    //                         }
    //                         .no-print {
    //                             display: none;
    //                         }
    //                     }
    //                 `}
    //             </style>
    //         </div>
    //     );
    // };

    return (
        <div style={containerStyle}>
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '0px' }}>
                <img src={logo} alt="Company Logo" style={{ maxHeight: '80px', margin: '0 auto', marginLeft: '250px' }} />
            </div>

            <div className="w-full sm:w-1/2">
                <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                    <tbody>
                        <tr>
                            <td style={{ width: '50%', textAlign: 'right', padding: 0 }}>
                                <h3 style={{ textAlign: 'right', marginTop: '20px' }}>Bill No : #{labelData.ReferenceNo}</h3>
                                <h3 style={{ textAlign: 'right', padding: 0 }}>Bill Date: {formatDate(labelData.ReferenceDate)}</h3>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <div className="w-full sm:w-1/2">
                <table style={{ width: '100%', marginTop: '30px', borderCollapse: 'collapse' }}>
                    <tbody>
                        <tr>
                            <td style={{ width: '100%', textAlign: 'center', padding: 0 }}>
                                <h2 style={{ textAlign: 'center', padding: '0 0 5px 0', margin: 0 }}>ABK Hostel - Caution Fee Refund Form</h2>
                            </td>
                        </tr>
                        <tr>
                            <td style={{ width: '100%', textAlign: 'center', padding: 0 }}>
                                <h4 style={{ textAlign: 'left', padding: '0 0 5px 0', margin: 0 }}>Tenant Details</h4>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>

            {/* <div className="w-full sm:w-1/2">
                <table style={{ width: '100%', marginTop: '30px', borderCollapse: 'collapse' }}>
                    <tbody>
                        <tr>
                            <td colSpan={2} style={{ textAlign: 'left', padding: 0 }}>
                                <h4 style={{ margin: 0, fontWeight: 'normal' }}>Name : {labelData.PartyName}</h4>
                            </td>
                        </tr>
                        <tr>
                            <td colSpan={2} style={{ textAlign: 'left', padding: 0 }}>
                                <h4 style={{ margin: 0, fontWeight: 'normal' }}>Room Number : {labelData.RoomName}</h4>
                            </td>
                        </tr>
                        <tr>
                            <td colSpan={2} style={{ textAlign: 'left', padding: 0 }}>
                                <h4 style={{ margin: 0, fontWeight: 'normal' }}>Check-in Date : {formatDate(labelData.CheckInDate)}</h4>
                            </td>
                        </tr>
                        <tr>
                            <td colSpan={2} style={{ textAlign: 'left', padding: 0 }}>
                                <h4 style={{ margin: 0, fontWeight: 'normal' }}>Check-out Date : {formatDate(labelData.CheckOutDate)}</h4>
                            </td>
                        </tr>
                        <tr>
                            <td colSpan={2} style={{ textAlign: 'left', padding: 0 }}>
                                <h4 style={{ margin: 0, fontWeight: 'normal' }}>Contact Number : {labelData.PartyContactNo}</h4>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div> */}

            <div className="w-full sm:w-1/2">
                <table style={{ width: '100%', marginTop: '30px', borderCollapse: 'collapse' }}>
                    <tbody>
                        <tr>
                            <td colSpan={2} style={{ textAlign: 'left', padding: 0 }}>
                                <h4 style={{ margin: 0, fontWeight: 'normal' }}>
                                    Name <span style={{ marginLeft: '100px' }}> : </span><span style={{ marginLeft: '15px' }}>{labelData.PartyName}</span>
                                </h4>
                            </td>
                        </tr>
                        <tr>
                            <td colSpan={2} style={{ textAlign: 'left', padding: 0 }}>
                                <h4 style={{ margin: 0, fontWeight: 'normal' }}>
                                    Room Number <span style={{ marginLeft: '38px' }}> :</span> <span style={{ marginLeft: '15px' }}>{labelData.RoomName}</span>
                                </h4>
                            </td>
                        </tr>
                        <tr>
                            <td colSpan={2} style={{ textAlign: 'left', padding: 0 }}>
                                <h4 style={{ margin: 0, fontWeight: 'normal' }}>
                                    Check-in Date <span style={{ marginLeft: '40.1px' }}> : </span><span style={{ marginLeft: '15px' }}> {formatDate(labelData.CheckInDate)}</span>
                                </h4>
                            </td>
                        </tr>
                        <tr>
                            <td colSpan={2} style={{ textAlign: 'left', padding: 0 }}>
                                <h4 style={{ margin: 0, fontWeight: 'normal' }}>
                                    Check-out Date <span style={{ marginLeft: '30.1px' }}> : </span><span style={{ marginLeft: '15px' }}>{formatDate(labelData.CheckOutDate)}</span>
                                </h4>
                            </td>
                        </tr>
                        <tr>
                            <td colSpan={2} style={{ textAlign: 'left', padding: 0 }}>
                                <h4 style={{ margin: 0, fontWeight: 'normal' }}>
                                    Contact Number <span style={{ marginLeft: '25px' }}> : </span><span style={{ marginLeft: '15px' }}>{labelData.PartyContactNo}</span>
                                </h4>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <div className="w-full sm:w-1/2">
                <table style={{ width: '100%', marginTop: '30px', borderCollapse: 'collapse' }}>
                    <tbody>
                        <tr>
                            <td style={{ width: '100%', textAlign: 'center', padding: 0 }}>
                                <h4 style={{ textAlign: 'left', padding: '0 0 5px 0', margin: 0 }}>Refund Information:</h4>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <div className="w-full sm:w-1/2">
                <table style={{ width: '100%', marginTop: '30px', borderCollapse: 'collapse' }}>
                    <tbody>
                        <tr>
                            <td colSpan={2} style={{ textAlign: 'left', padding: 0 }}>
                                <h4 style={{ margin: 0, fontWeight: 'normal' }}>Total Caution Fee Paid <span style={{ marginLeft: '40.1px' }}> : </span><span style={{ marginLeft: '15px' ,fontSize:'18px'}}>₹ {labelData.CautionAmount}</span></h4>
                            </td>
                        </tr>
                        <tr>
                            <td colSpan={2} style={{ textAlign: 'left', padding: 0 }}>
                                <h4 style={{ margin: 0, fontWeight: 'normal' }}>Deductions (if any)  <span style={{ marginLeft: '68.1px' }}> : </span><span style={{ marginLeft: '15px' ,fontSize:'18px'}}>₹ {totalDeductions}</span></h4>
                            </td>
                        </tr>
                        <tr>
                            <td colSpan={2} style={{ textAlign: 'left', padding: 0 }}>
                                <h4 style={{ margin: 0, fontWeight: 'normal' }}>Reason for Deductions  <span style={{ marginLeft: '38.1px' }}> : </span><span style={{ marginLeft: '15px'}}></span>{labelData.Remarks}</h4>
                            </td>
                        </tr>
                        <tr>
                            <td colSpan={2} style={{ textAlign: 'left', padding: 0 }}>
                                <h4 style={{ margin: 0, fontWeight: 'normal' }}>Amount to be Refunded <span style={{ marginLeft: '32.1px' }}> : </span><span style={{ marginLeft: '15px' ,fontSize:'18px'}}>₹ {labelData.RefundAmount}</span></h4>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <div className="w-full sm:w-1/2">
                <table style={{ width: '100%', marginTop: '30px', borderCollapse: 'collapse' }}>
                    <tbody>
                        <tr>
                            <td style={{ width: '100%', textAlign: 'left', padding: 0 }}>
                                <h4 style={{ textAlign: 'left', padding: '0 0 5px 0', margin: 0 }}>Payment Type :</h4>
                            </td>
                        </tr>
                        <tr>
                            <td colSpan={2} style={{ textAlign: 'left', padding: 0 }}>
                                <h4 style={{ margin: 0, fontWeight: 'normal' }}>{labelData.PaymentType}</h4>
                            </td>
                        </tr>
                        <tr>
                            <td colSpan={2} style={{ textAlign: 'left', padding: 0 }}>
                                <h4 style={{ margin: 0, fontWeight: 'normal' }}>{formatDate(labelData.PaymentSaledate)}</h4>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <div className="w-full sm:w-1/2">
                <table style={{ width: '100%', marginTop: '30px', borderCollapse: 'collapse' }}>
                    <tbody>
                        <tr>
                            <td style={{ width: '40%', textAlign: 'left', padding: 0 }}>
                                <h4 style={{ fontSize: '16px' }}><AmountInWords amount={labelData.RefundAmount} /></h4>
                            </td>
                            <td style={{ width: '60%', textAlign: 'right', padding: 0 }}>
                                <h4 style={{ textTransform: 'uppercase' }}>For {labelData.CompanyName}</h4>
                                <h4 style={{ marginTop: '25px', marginBottom: '2px' }}>Signature</h4>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>

            {/* Print-specific styles */}
            <style>
                {`
                @media print {
                    body {
                        margin: 10;
                        padding: 0;
                    }
                    @page {
                        size: A4;
                        margin: 0;
                    }
                    .no-print {
                        display: none;
                    }
                }
            `}
            </style>
        </div>
    );
}


export default BillPrint;
